<template>
  <v-card>
    <v-card-title class="d-flex justify-center">
      <v-spacer />
      فرم ابلاغ سفارش شماره :
      <span class="blue--text">
        {{
          tradeRequest && tradeRequest.tradeNumber
            ? ' ' + tradeRequest.tradeNumber + ' '
            : ''
        }}
      </span>
      <v-spacer />

      نام کسب و کار :
      <span class="blue--text">
        {{
          tradeRequest && tradeRequest.merchantName
            ? ' ' + tradeRequest.merchantName + ' '
            : ''
        }}
      </span>
      <v-spacer />

      به تاریخ :
      <span class="red--text">
        {{
          tradeRequest && tradeRequest.createdTimeUtc
            ? ' ' + jalaliDate(tradeRequest.createdTimeUtc) + ' '
            : ''
        }}
      </span>
      <v-spacer />
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="formValid">
        <v-sheet outlined color="blue">
          <v-card outlined elevation="0" class="pa-5">
            <v-row>
              <v-col cols="12">
                <strong class="red--text">
                  خلاصه
                  {{ tradeRequestDisplayName(tradeRequest.request) }}
                </strong>
              </v-col>
              <v-col cols="6" sm="4" md="3">
                تاریخ سفارش:
                <strong>
                  {{
                    tradeRequest && tradeRequest.createdTimeUtc
                      ? jalaliDate(tradeRequest.createdTimeUtc)
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col cols="6" sm="4" md="3"
                >مهلت ارسال پاسخ:
                <strong>
                  {{
                    tradeRequest && tradeRequest.bidExpirationTimeInDays >= 0
                      ? tradeRequest.bidExpirationTimeInDays + 'روز'
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request == 'ContractorRecognition'
                "
                >مدت زمان اجرای طرح:
                <strong>
                  {{
                    tradeRequest && tradeRequest.runningDuration >= 0
                      ? tradeRequest.runningDuration + 'ماه'
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                موضوع:
                <strong>
                  {{ tradeItem && tradeItem.title ? tradeItem.title : '' }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
                >تعداد:
                <strong>
                  {{
                    tradeItem && tradeItem.quantity ? tradeItem.quantity : ''
                  }}
                  {{
                    tradeItem && tradeItem.measurementUnitTitle
                      ? tradeItem.measurementUnitTitle
                      : ''
                  }}</strong
                >
              </v-col>

              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
                >جنس مواد:
                <strong>
                  {{
                    tradeItem && tradeItem.rawMaterialName
                      ? tradeItem.rawMaterialName
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col cols="6" sm="4" md="3"
                >دسته سفارش:
                <strong>
                  {{
                    tradeRequest && tradeRequest.category
                      ? tradeCategoryDisplayName(tradeRequest.category)
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                روش پرداخت:
                <strong>
                  {{
                    tradeRequest && tradeRequest.paymentMethod
                      ? paymentMethodDisplayName(tradeRequest.paymentMethod)
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request == 'ContractorRecognition'
                "
              >
                نوع تضمین:
                <strong>
                  {{
                    tradeRequest && tradeRequest.guarantee
                      ? guaranteeMethodDisplayName(tradeRequest.guarantee)
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col cols="12">
                <label
                  v-if="
                    tradeRequest &&
                    tradeRequest.request == 'ContractorRecognition'
                  "
                >
                  عنوان:
                </label>
                <label v-else> موضوع سفارش: </label>
                <strong>
                  {{
                    tradeRequest && tradeRequest.content
                      ? tradeRequest.content
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="12"
                v-if="
                  tradeRequest &&
                  tradeRequest.request == 'ContractorRecognition'
                "
              >
                شرح طرح/پروژه :
                <strong>
                  {{
                    tradeRequest && tradeRequest.orderDescription
                      ? tradeRequest.orderDescription
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
                >نحوه تامین مواد:
                <strong>
                  {{
                    tradeItem && tradeItem.materialSupplyType
                      ? materialSupplyTypeDisplayName(
                          tradeItem.materialSupplyType
                        )
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
                >محل تحویل سفارش:
                <strong>
                  {{
                    tradeItem && tradeItem.deliveryLocation
                      ? DeliveryLocationDisplayName(tradeItem.deliveryLocation)
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
                >شروع تحویل دهی:
                <strong>
                  {{
                    tradeItem && tradeItem.requireDateUtc
                      ? jalaliDate(tradeItem.requireDateUtc)
                      : ''
                  }}</strong
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                <div class="mb-1">
                  <strong class="blue--text"> جدول تحویل دهی: </strong>
                </div>
                <v-card class="mx-2">
                  <v-data-table
                    :headers="deliveryItemHeader"
                    :items="tradeItem.deliveryItems"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:[`item.deliveryDateUtc`]="{ item }">
                      {{ jalaliDate(item.deliveryDateUtc) }}
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" class="pa-4">
                <v-sheet
                  class="mt-5 justify-center"
                  v-if="tradeItem.documents && tradeItem.documents.length"
                >
                  <v-row v-if="tradeItem.isDefault" class="text-center">
                    <v-col
                      cols="12"
                      v-for="(x, i) in tradeItem.documents"
                      :key="i"
                    >
                      <div v-if="x.isDefault">
                        <v-col cols="12">
                          <v-img
                            v-if="x.fileId && x.fileId.fileUrl"
                            :src="x.fileId.fileUrl"
                            max-height="200px"
                            max-width="200px"
                          />
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else class="text-center">
                    <v-col cols="12">
                      <v-img
                        v-if="
                          tradeItem.documents[0] &&
                          tradeItem.documents[0].fileId &&
                          tradeItem.documents[0].fileId.fileUrl
                        "
                        :src="tradeItem.documents[0].fileId.fileUrl"
                        height="200px"
                        width="200px"
                      />
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                v-if="tradeRequest && tradeRequest.category == 'Product' && tradeRequest.request != 'DirectOrder'"
              >
                <strong class="blue--text">
                  مشخصات {{ tradeItem.techInfos[0].productCategoryName }}
                </strong>
                <v-sheet outlined width="98%" class="pa-5 ma-2">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      v-for="(property, index) in tradeItem.techInfos[0]
                        .tradeRequestItemPropertyValues"
                      :key="index"
                    >
                      <v-row>
                        <v-col cols="12" sm="4">
                          <label
                            >{{ property.categoryPropertyTitle }} :
                          </label></v-col
                        >

                        <v-col cols="12" sm="8">
                          <strong
                            v-if="property.propertyType == 'MultiSelectList'"
                          >
                            <label
                              v-for="(prop, index) in property.value.split('|')"
                              :key="index"
                            >
                              {{ prop.replaceAll('null', '') }}
                              <label
                                v-if="
                                  index <
                                    property.value.split('|').length - 1 && prop
                                "
                              >
                                -
                              </label>
                            </label>
                          </strong>
                          <strong
                            v-else-if="property.propertyType == 'Logical'"
                          >
                            {{ property.value == true ? 'بله' : 'خیر' }}
                          </strong>
                          <strong v-else
                            >{{
                              property.maxValue
                                ? `از ${property.value} تا ${property.maxValue}`
                                : property.value
                            }}
                            {{ property.measurementUnitDisplayText }}</strong
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col cols="12" class="pa-4">
                <strong class="mr-3 blue--text"
                  >مدارک مورد نیاز جهت پاسخ
                </strong>
                <v-sheet
                  outlined
                  class="mt-5 justify-center"
                  v-if="
                    tradeItem.responseDocuments &&
                    tradeItem.responseDocuments.length
                  "
                >
                  <v-data-table
                    :items="tradeItem.responseDocuments"
                    :headers="responseDocumentHeader"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:[`item.isOptional`]="{ item }">
                      {{ item.isOptional ? 'اختیاری' : 'اجباری' }}
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-col>
              <!-- ------------------------------------------ -->
              <v-col cols="12">
                <strong class="mr-3 blue--text"
                  >مدارک و مستندات
                  {{ tradeRequestDisplayName(tradeRequest.request) }}
                  :</strong
                >
                <v-sheet outlined class="ma-3">
                  <v-data-table
                    :items="tradeItem.documents"
                    :headers="documentTableHeader"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.fileImage`]="{ item }">
                      <v-img
                        :src="
                          item.fileId && item.fileId.thumbnailFileUrl
                            ? item.fileId.thumbnailFileUrl
                            : ''
                        "
                        width="60px"
                      >
                      </v-img>
                    </template>
                    <template v-slot:[`item.documentTypeTitle`]="{ item }">
                      <v-btn
                        text
                        @click="
                          log(item);
                          selectedDoc = item;
                          documentModal = true;
                        "
                        >{{ item.documentTypeTitle }}</v-btn
                      >
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      {{
                        item.description == '' ? 'وارد نشده' : item.description
                      }}
                    </template>
                    <template v-slot:[`item.downloadLink`]="{ item }">
                      <a
                        target="_blank"
                        :href="
                          item.fileId && item.fileId.fileUrl
                            ? item.fileId.fileUrl
                            : ''
                        "
                        >{{
                          item.fileId && item.fileId.fileUrl ? 'دانلود' : ''
                        }}
                      </a>
                    </template>
                    <template v-slot:[`item.reviewed`]="{ item }">
                      <v-checkbox
                        @click="documentValidationPerItem(ind)"
                        v-model="item.checkboxConfirmation"
                      >
                      </v-checkbox>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <strong class="mr-3 blue--text">
                  {{
                    tradeRequest &&
                    tradeRequest.request != 'ContractorRecognition'
                      ? ' توضیحات سفارش '
                      : 'عنوان'
                  }}:
                </strong>
                <strong class="mr-3">
                  {{
                    tradeRequest && tradeRequest.content
                      ? tradeRequest.content
                      : 'وارد نشده'
                  }}
                </strong>
              </v-col>
              <v-col cols="12">
                <strong class="mr-3 blue--text"> شرح پروژه/ طرح :</strong>
                <strong
                  >{{
                    tradeRequest.orderDescription &&
                    tradeRequest.orderDescription.length
                      ? tradeRequest.orderDescription
                      : 'وارد نشده'
                  }}
                </strong>
              </v-col>
            </v-row>
          </v-card>
        </v-sheet>
        <v-sheet outlined color="blue" class="mt-5">
          <v-card outlined elevation="0" class="pa-5">
            <v-row>
              <v-col cols="12">
                <strong class="red--text">
                  خلاصه پیشنهاد به
                  {{ tradeRequestDisplayName(tradeRequest.request) }}
                  :
                </strong>
              </v-col>

              <v-col cols="6" sm="4" md="3"
                >نام شرکت کننده :
                <strong>
                  {{
                    winnerItem && winnerItem.supplierName
                      ? winnerItem.supplierName
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                موضوع :
                <strong>
                  {{ tradeItem && tradeItem.title ? tradeItem.title : '' }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                تعداد سفارش :
                <strong>
                  {{
                    winnerItem && winnerItem.totalAmount
                      ? winnerItem.totalAmount
                      : ''
                  }}

                  {{
                    tradeItem && tradeItem.measurementUnitTitle
                      ? tradeItem.measurementUnitTitle
                      : ''
                  }}</strong
                >
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                تعداد تخصیص :
                <strong>
                  {{
                    winnerItem && winnerItem.committedAmount
                      ? winnerItem.committedAmount
                      : ''
                  }}
                  {{
                    tradeItem && tradeItem.measurementUnitTitle
                      ? tradeItem.measurementUnitTitle
                      : ''
                  }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                قیمت واحد :
                <strong v-if="winnerItem && winnerItem.price">
                  {{ winnerItem.price.amount | priceSplitter }}
                  {{ ' ' + winnerItem.price.title }}
                </strong>
              </v-col>
              <v-col
                cols="6"
                sm="4"
                md="3"
                v-if="
                  tradeRequest &&
                  tradeRequest.request != 'ContractorRecognition'
                "
              >
                قیمت کل :
                <strong v-if="winnerItem && winnerItem.price">
                  {{
                    (winnerItem.price.amount * winnerItem.totalAmount)
                      | priceSplitter
                  }}{{ ' ' + winnerItem.price.title }}
                </strong>
              </v-col>
              <v-col cols="12">
                <strong class="mr-3 blue--text"
                  >مدارک و مستندات ارسالی شرکت کننده :</strong
                >
                <v-sheet outlined class="ma-3">
                  <v-data-table
                    :items="responseDocumentItems"
                    :headers="documentTableHeader"
                    hide-default-footer
                    disable-pagination
                  >
                    <template v-slot:[`item.fileImage`]="{ item }">
                      <v-img
                        :src="
                          item.fileId && item.fileId.thumbnailFileUrl
                            ? item.fileId.thumbnailFileUrl
                            : ''
                        "
                        width="60px"
                      >
                      </v-img>
                    </template>
                    <template v-slot:[`item.documentTypeTitle`]="{ item }">
                      <v-btn
                        text
                        @click="
                          log(item);
                          selectedDoc = item;
                          documentModal = true;
                        "
                        >{{ item.documentTypeTitle }}</v-btn
                      >
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      {{
                        item.description == '' ? 'وارد نشده' : item.description
                      }}
                    </template>
                    <template v-slot:[`item.downloadLink`]="{ item }">
                      <a
                        target="_blank"
                        :href="
                          item.fileId && item.fileId.fileUrl
                            ? item.fileId.fileUrl
                            : ''
                        "
                        >{{
                          item.fileId && item.fileId.fileUrl ? 'دانلود' : ''
                        }}
                      </a>
                    </template>
                    <template v-slot:[`item.reviewed`]="{ item }">
                      <v-checkbox
                        @click="documentValidationPerItem(ind)"
                        v-model="item.checkboxConfirmation"
                      >
                      </v-checkbox>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-col>
              <v-col cols="12">
                <strong class="mr-3 blue--text">توضیحات پاسخ :</strong>
                <strong class="mr-3">
                  {{
                    winnerItem && winnerItem.description
                      ? winnerItem.description
                      : 'وارد نشده'
                  }}
                </strong>
              </v-col>
              <v-col cols="12">
                <strong class="mr-3 blue--text"> توجه: </strong>
                <strong>
                  کلیه شرایط این سفارش شامل مستندات فنی، اعم از مشخصات، شرایط و
                  زمان تحویل، که در قالب مستندات پیوست و سایر اطلاعات موجود در
                  سفارش ثبت و اعلام شده است، توسط شرکت کننده

                  <span class="blue--text">
                    {{
                      winnerItem && winnerItem.supplierName
                        ? '(' + winnerItem.supplierName + ')'
                        : ''
                    }}</span
                  >
                  بررسی و تائید شده است .به عبارت دیگر کلیه شرایط و الزامات
                  منتشر شده در استعلام مورد تائید بوده و قیمت و شرایط اعلامی
                  شرکت در این استعلام با لحاظ آن شرایط پیشنهاد شده است.
                </strong>
              </v-col>
            </v-row>
          </v-card>
        </v-sheet>
        <v-sheet outlined color="blue" class="mt-5">
          <v-card outlined elevation="0" class="pa-5">
            <strong class="red--text">
              ابلاغ برنده
              {{ tradeRequestDisplayName(tradeRequest.request) }}
              :
            </strong>
            <v-row class="pa-4">
              <v-col cols="12">
                <strong>
                  مدیر/ مدیرعامل محترم
                  <span class="blue--text">
                    {{
                      winnerItem && winnerItem.supplierName
                        ? winnerItem.supplierName
                        : ''
                    }}
                  </span>
                  <br />

                  نظر به اینکه کسب و کار
                  <span class="blue--text">
                    {{
                      winnerItem && winnerItem.supplierName
                        ? winnerItem.supplierName
                        : ''
                    }}
                  </span>
                  در استعلام با مشخصات فوق شرکت نموده و کلیه شرایط و موارد
                  اعلامی را پذیرفته است، بدینوسیله اعلام میشود کسب و کار
                  <span class="blue--text">
                    {{
                      tradeRequest && tradeRequest.merchantName
                        ? ' ' + tradeRequest.merchantName + ' '
                        : ''
                    }}
                  </span>
                  آماده توافق یا عقد قرارداد و سفارش گذاري موضوع
                  {{ tradeRequestDisplayName(tradeRequest.request) }}
                  {{
                    tradeRequest &&
                    tradeRequest.request != 'ContractorRecognition'
                      ? 'به'
                      : ''
                  }}
                </strong>
                <strong
                  v-if="
                    tradeRequest &&
                    tradeRequest.request != 'ContractorRecognition'
                  "
                >
                  <v-row class="pa-5">
                    <v-col cols="3">
                      تعداد:
                      <span class="blue--text">
                        {{
                          tradeItem && tradeItem.quantity
                            ? tradeItem.quantity
                            : ''
                        }}</span
                      >
                    </v-col>
                    <v-col cols="5">
                      قیمت واحد :
                      <span
                        class="blue--text"
                        v-if="winnerItem && winnerItem.price"
                      >
                        {{ winnerItem.price.amount | priceSplitter
                        }}{{ ' ' + winnerItem.price.title }}
                      </span>
                    </v-col>
                    <v-col cols="4">
                      قیمت کل :
                      <span
                        class="blue--text"
                        v-if="winnerItem && winnerItem.price"
                      >
                        {{
                          (winnerItem.price.amount * winnerItem.totalAmount)
                            | priceSplitter
                        }}{{ ' ' + winnerItem.price.title }}
                      </span>
                    </v-col>
                  </v-row>
                </strong>
                <strong>
                  را دارد. خواهشمند است حداکثر ظرف مدت 7روز از طریق تلفنهاي تماس
                  موجود در سفارش تماس حاصل نمایید طبیعتاً در صورت عدم همکاري بعد
                  از گذشت زمان فوق ،
                  <span class="blue--text">
                    {{
                      tradeRequest && tradeRequest.merchantName
                        ? ' ' + tradeRequest.merchantName + ' '
                        : ''
                    }}
                  </span>
                  مختار است که موضوع سفارش را به دیگر پیشنهاد دهندگان واگذار
                  نماید.
                </strong>
                <label class="d-flex justify-center">
                  <strong>
                    با تقدیم احترام:

                    {{
                      tradeRequest && tradeRequest.merchantName
                        ? tradeRequest.merchantName
                        : ''
                    }}-
                    {{
                      tradeRequest && tradeRequest.ownerName
                        ? tradeRequest.ownerName
                        : ''
                    }}
                  </strong>
                </label>
              </v-col>
            </v-row>
          </v-card>
        </v-sheet>
        <v-sheet outlined color="blue" class="mt-5">
          <v-card outlined elevation="0" class="pa-5">
            <strong class="red--text"> توضیحات و هشدار تکصان: </strong>
            <v-row class="pa-4">
              <v-col cols="12">
                <strong v-html="body"></strong>
              </v-col>
            </v-row>
          </v-card>
        </v-sheet>
        <div class="py-3">
          <strong>
            راهنمایی: در صورت بروز اشکال و خطا در فرم فوق میتوانید از طریق
            <a :href="$store.getters.crmExtrnalUrl" target="_blank"
              >لینک پشتیبانی</a
            >
            با صدور تیکت، اطلاع رسانی نمایید
          </strong>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="mx-1"
            @click="finalizing"
            v-if="winnerItem.itemStatus != 'Won' && !finalizeFlag"
            >ابلاغ سفارش</v-btn
          >
          <v-btn color="error" class="mx-1" @click="$router.go(-1)">
            بستن
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
    <v-dialog
      v-if="documentModal && selectedDoc != null"
      v-model="documentModal"
      width="500px"
    >
      <v-card>
        <v-card-title>{{ selectedDoc.documentTypeTitle }} </v-card-title>
        <v-img
          :src="
            selectedDoc.fileId && selectedDoc.fileId.fileUrl
              ? selectedDoc.fileId.fileUrl
              : ''
          "
          class="d-flex justify-center"
          max-width="300px"
          max-height="300px"
        >
        </v-img>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <label for="">توضیحات:</label>
              <strong>
                {{ selectedDoc.description }}
              </strong>
            </v-col>
            <v-col cols="12">
              <a
                target="_blank"
                :href="
                  selectedDoc.fileId && selectedDoc.fileId.fileUrl
                    ? selectedDoc.fileId.fileUrl
                    : ''
                "
                >{{
                  selectedDoc.fileId && selectedDoc.fileId.fileUrl
                    ? 'دانلود فایل'
                    : ''
                }}
              </a>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="
              selectedDoc = [];
              documentModal = false;
            "
            >بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="finalizeModal" v-model="finalizeModal" max-width="400px">
      <v-card>
        <v-toolbar color="primary" dark dense>توجه</v-toolbar>
        <v-card-text class="mt-3">
          <strong>
            بعد از ابلاغ امکان انصراف یا ویرایش وجود نخواهد داشت. آیا از ابلاغ
            مطمئن هستید؟
          </strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small color="error" @click="finalizeModal = false">
            خیر
          </v-btn>
          <v-btn small color="success" @click="finalize">بله </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-actions></v-card-actions>
  </v-card>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
const pagesRepository = () => RepoFactory.get('pages');
import TradeRequestInformationTable from '../../components/TradeRequestInformationTable';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import Helper from '@/core/helpers';
const enumsRepository = () => RepoFactory.get('enums');
const tradeRequestResponseRepository = () =>
  RepoFactory.get('tradeRequestResponse');
const tradeRequestsRepository = () => RepoFactory.get('tradeRequests');
const tradeResponseRepository = () => RepoFactory.get('tradeResponse');
export default {
  components: {
    TradeRequestInformationTable,
  },
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  data() {
    return {
      finalizeFlag: false,
      finalizeModal: false,
      title: '',
      body: '',
      SupplierInfo: [],
      selectedDoc: [],
      documentModal: false,
      tradeGuaranteeList: [],
      materialSupplyTypeList: [],
      tradeCategoriesList: [],
      deliveryDurationTypeList: [],
      deliveryLocationList: [],
      tradeRequestTypeList: [],
      tradePaymentMethodList: [],
      rawMaterialSupplyTypesList: [],
      winnerMerchantInfo: [],
      responseDocumentItems: [],
      tradeResponse: null,
      tradeRequest: null,
      formValid: true,
      check1: true,
      check2: true,
      check3: true,
      items: [],
      responseDocumentHeader: [
        {
          value: 'isOptional',
          text: 'اختیار الصاق',
          sortable: true,
        },
        {
          value: 'documentTypeTitle',
          text: 'عنوان اصلی ',
          sortable: true,
        },
        {
          value: 'subTitle',
          text: 'عنوان دلخواه',
          sortable: true,
        },
      ],
      headers: [
        {
          value: 'documentTypeTitle',
          text: 'نام کسب و کار منتخب',
          sortable: false,
        },
        {
          value: 'documentTypeTitle',
          text: 'موضوع',
          sortable: false,
        },
        {
          value: 'documentTypeTitle',
          text: 'تعداد سفارش',
          sortable: false,
        },
        {
          value: 'documentTypeTitle',
          text: 'تعداد تخصیص',
          sortable: false,
        },
        {
          value: 'documentTypeTitle',
          text: 'واحد',
          sortable: false,
        },
        {
          value: 'documentTypeTitle',
          text: 'قیمت',
          sortable: false,
        },
      ],
      documentTableHeader: [
        {
          text: 'تصویر',
          value: 'fileImage',
        },
        {
          text: 'نوع سند',
          value: 'documentTypeTitle',
        },
        {
          text: 'توضیحات',
          value: 'description',
        },
        {
          text: 'دانلود فایل',
          value: 'downloadLink',
        },
      ],
      deliveryItemHeader: [
        {
          text: 'تعداد',
          value: 'amount',
        },
        {
          text: 'تاریخ',
          value: 'deliveryDateUtc',
        },
      ],
      tradeRequestInformationFields: [
        {
          value: 'productCategoryName',
          text: 'نام فعالیت',
          sortable: false,
        },
        {
          value: 'processType',
          text: 'نوع فرآیند',
          sortable: false,
        },
        {
          value: 'breadcrumb.breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    tradeCategoryDisplayName(title) {
      if (this.tradeCategoriesList.length) {
        let result = this.tradeCategoriesList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeRequestDisplayName(title) {
      if (this.tradeRequestTypeList.length) {
        let result = this.tradeRequestTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    paymentMethodDisplayName(title) {
      if (this.tradePaymentMethodList.length) {
        let result = this.tradePaymentMethodList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryDurationDisplayName(title) {
      if (this.deliveryDurationTypeList.length) {
        let result = this.deliveryDurationTypeList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    materialSupplyTypeDisplayName(title) {
      if (this.rawMaterialSupplyTypesList.length) {
        let result = this.rawMaterialSupplyTypesList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryLocationDisplayName(title) {
      if (this.deliveryLocationList.length) {
        let result = this.deliveryLocationList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeCategories() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('CategoryTypeItems', this.tradeBaseUrl)
        .then((res) => {
          this.tradeCategoriesList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    deliveryDurationType() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('DeliveryDurationType', this.tradeBaseUrl)
        .then((res) => {
          this.deliveryDurationTypeList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    deliveryLocationType() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('DeliveryLocationType', this.tradeBaseUrl)
        .then((res) => {
          this.deliveryLocationList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    tradeRequestType() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('TradeRequestType', this.tradeBaseUrl)
        .then((res) => {
          this.tradeRequestTypeList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    tradePaymentMethod() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('TradePaymentMethodType', this.tradeBaseUrl)
        .then((res) => {
          this.tradePaymentMethodList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    rawMaterialSupplyTypes() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('RawMaterialSupplyType', this.tradeBaseUrl)
        .then((res) => {
          this.rawMaterialSupplyTypesList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    getWinnerInfo() {},
    getSupplierInfo() {
      let app = this;
      const loader = this.$loading.show();
      merchantRepository()
        .getMerchantInformationById(
          this.tradeRequest.merchantId,
          this.merchantBaseUrl
        )
        .then(({ data }) => {
          app.SupplierInfo = data;

          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    log(item) {
      console.log(item);
    },
    guaranteeMethodDisplayName(title) {
      if (this.tradeGuaranteeList.length) {
        let result = this.tradeGuaranteeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    tradeGuaranteeMethod() {
      const loader = this.$loading.show();
      enumsRepository()
        .getEnum('GuaranteeType', this.tradeBaseUrl)
        .then((res) => {
          this.tradeGuaranteeList = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    getDocument() {
      let app = this;
      const loader = this.$loading.show();

      tradeRequestResponseRepository()
        .getDocuments(
          this.winnerItem.tradeResponseId,
          this.tradeBaseUrl,
          {},
          { responseItemId: this.winnerItem.tradeResponseItemId }
        )
        .then((res) => {
          // app.documentItems[slotData.index] = []
          res.data.forEach((x, i) => {
            x.checkboxConfirmation = false;
            x.confirmed = false;
            x.rejected = false;
            x.index = i;
            app.responseDocumentItems.push(x);
          });
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    getPageData() {
      let params = {
        uniquePageName: this.uniquePageName,
      };
      const loader = this.$loading.show();
      pagesRepository()
        .getUniquePage(this.contentBaseUrl, {}, params)
        .then(({ data }) => {
          this.title = data.title;
          this.body = data.body;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    finalizing() {
      this.finalizeModal = true;
    },
    finalize() {
      let body = {
        tradeResponseItemId: this.winnerItem.tradeResponseItemId,
      };
      const loader = this.$loading.show();
      tradeResponseRepository()
        .win(this.winnerItem.tradeResponseId, body, this.tradeBaseUrl, {
          merchantId: this.$store.getters.currentMerchant,
        })
        .then((res) => {
          this.$dialog.message.success('سفارش با موفقیت ابلاغ شد.', {
            position: 'top-left',
          });
          this.winnerItem.itemStatus = 'Won';
          this.finalizeFlag = true;
          this.finalizeModal = false;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
  },
  created() {
    this.winnerItem = this.$store.getters.tradeRequestSelectedToFinalize;
    this.tradeItem = this.$store.getters.tradeRequestResponsesHeader;
    this.tradeRequest = this.$store.getters.tradeRequestSelectedForDisplay;
    this.tradeCategories();
    this.tradePaymentMethod();
    this.deliveryLocationType();
    this.rawMaterialSupplyTypes();
    this.getWinnerInfo();
    this.getSupplierInfo();
    this.getDocument();
    this.getPageData();
    this.tradeGuaranteeMethod();
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    tradeBaseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    contentBaseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    uniquePageName() {
      return this.$store.getters.pageOrderWinnerNoticesFromTakssan;
    },
  },
};
</script>

<style></style>
